"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomApiTransformError = void 0;
const ErrorUtil_1 = require("../../../../api/ErrorUtil");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
class CustomApiTransformError {
    constructor(jsonData) {
        this.jsonData = jsonData;
    }
    parseError(handler) {
        this.parseErrorHandler = response => handler(response);
        return this;
    }
    static get default() {
        const basicError = new CustomApiTransformError();
        basicError.parseError(e => {
            return ErrorUtil_1.ErrorUtil.defaultErrorMsg;
        });
        throw basicError;
    }
    get errorDescription() {
        if (this.parseErrorHandler != null) {
            const message = this.parseErrorHandler(this);
            if (!(0, is_blank_1.default)(message)) {
                return message;
            }
        }
        return undefined;
    }
}
exports.CustomApiTransformError = CustomApiTransformError;
